import styled from "styled-components";

export const CardsStyle = styled.div`
  padding: 58px 0px;
`;
